import { Component, Inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { SeperatorComponent } from '../../eqform';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';

@Component({
  selector: 'eq-cnf-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatTableModule
  ],
  templateUrl: './popup-message-tabular.component.html',
  styleUrl: './popup-message-tabular.component.scss',
})
export class PopupMessageTabularComponent implements OnInit {
  mainHeader!: string[];
  header!: string[];
  rows!: string[][];
  displayedColumns!: string[];
  constructor(
    public dialogRef: MatDialogRef<PopupMessageTabularComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.mainHeader = this.data?.mainHeader;
    this.header = this.data?.header;
    this.rows = this.data?.rows;
    this.displayedColumns = Object.keys(this.data?.rows[0]);
  }
}
